import { makeStyles, Theme } from '@material-ui/core';

export const useSetupStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    minHeight: '100vh',
    alignItems: 'center',
    backgroundColor: '#EDF2F7',
    padding: theme.spacing(2),
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    maxWidth: '600px',
    padding: theme.spacing(4),
    gap: '8px',
    margin: 'auto',
    boxShadow:
      'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
    borderRadius: theme.spacing(1),
    backgroundColor: '#FFF',
  },
  title: {
    fontSize: '2.75rem',
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: theme.spacing(1),
  },
  loginTitle: {
    color: '#3b3b3b',
    fontSize: 20,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  stepContent: {
    padding: theme.spacing(2),
    minWidth: 400,
    [theme.breakpoints.down(479)]: {
      minWidth: 'fit-content',
    },
  },
  textField: {
    width: '100%',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    backgroundColor: '#F5F5F5',
    borderRadius: '10px',
  },
  inputStyle: {
    border: 0,
    backgroundColor: 'white',
    color: '#000000',
  },
  formLabel: {
    color: '#2158D0',
    display: 'block',
    textAlign: 'left',
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '28.79px',
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    marginTop: '0px',
    marginBottom: '-8px',
  },
  submitBtn: {
    background: '#5C91FF',
    color: '#FFFFFF',
    textTransform: 'capitalize' as const,
    borderRadius: 6,
    padding: '11px 11px',
    marginBottom: theme.spacing(2),
    '&:hover': {
      background: '#5C91FF',
    },
    fontWeight: 700,
    fontSize: '20px',
  },
  backBtn: {
    textTransform: 'capitalize' as const,
    borderRadius: 6,
    padding: '11px 11px',
    fontWeight: 700,
    fontSize: '16px',
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(3),
    gap: theme.spacing(2),
  },
  paragraphText: {
    display: 'block',
    textAlign: 'center',
    color: '#000000',
    fontWeight: 400,
    fontSize: '20px',
    lineHeight: '28.79px',
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  singupLink: {
    color: '#2158D0',
    cursor: 'pointer',
    textDecoration: 'none',
  },
  channelRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '4px 0',
  },
  addChannelRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
}));
